// Daily login reward — pure streak/reward logic shared by both backends. Claim
// once per UTC day (same day key as quests, so they roll over together). A streak
// of consecutive days escalates the payout on a 7-day cycle and resets to day 1
// if a day is missed. Rewards are flies.

export const DAILY_CYCLE = 7;
export const DAILY_REWARDS = [25, 40, 60, 90, 130, 180, 300]; // day 1..7, then repeats

export function dailyReward(streak) {
  const s = Math.max(1, Math.floor(Number(streak) || 1));
  return DAILY_REWARDS[(s - 1) % DAILY_CYCLE];
}

// The UTC calendar day immediately before `day` ("2026-06-05" -> "2026-06-04").
export function prevDay(day) {
  const t = Date.parse(`${day}T00:00:00Z`);
  if (Number.isNaN(t)) return null;
  return new Date(t - 86400000).toISOString().slice(0, 10);
}

// Given the stored last-claim day + streak and today's key, what claiming now
// yields: the resulting streak, the reward, and whether it's already been claimed.
export function computeClaim(lastDay, streak, today) {
  if (lastDay === today) {
    const s = Math.max(1, Math.floor(Number(streak) || 1));
    return { alreadyClaimed: true, streak: s, reward: dailyReward(s) };
  }
  const continuing = !!lastDay && lastDay === prevDay(today);
  const newStreak = continuing ? Math.max(1, Math.floor(Number(streak) || 0)) + 1 : 1;
  return { alreadyClaimed: false, streak: newStreak, reward: dailyReward(newStreak) };
}
